import React from "react";
import TrainingContentList from "./TrainingContentList";

const FMSDocumentation = () => {
  return (
    <TrainingContentList
      category="fms-document"
      title="FMS Documentation"
      breadcrumbs={["Training Library", "FMS Documentation"]}
    />
  );
};

export default FMSDocumentation;
